import React from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";

import WebLogoSvg from "../assets/images/logowhite.svg";
import Appstorelogo from "../assets/images/Appstorelogo.svg";
import Appstorelogo1 from "../assets/images/Appstorelogo1.svg";

const Footer = () => {
  const navigate = useNavigate();

  const pagesData = [
    {
      title: "How It Works",
      linkTo: "/how-it-works",
    },
    {
      title: "About",
      linkTo: "/about-us",
    },

    {
      title: "Contact Us",
      linkTo: "/contact-us",
    },
  ];
  const legalData = [
    {
      title: "Terms of Services",
      linkTo: "terms-condition",
    },
    {
      title: "Privacy Policy",
      linkTo: "privacy-policy",
    },
  ];

  const navigateToPage = (pageLink) => {
    navigate(pageLink);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <div className="footer-main">
      <div className="divfirst container pt-5 pb-5">
        <div className="row pt-4 pb-4">
          <div className="col-lg-4 col-md-6">
            <div className="">
              <img
                src={WebLogoSvg}
                className="cursor-pointer applogo"
                alt="appLogo"
                onClick={() => {
                  navigateToPage("/");
                }}
              />
            </div>

            <p className="mt-3 white  px-md-3 font-face-PlusJakartaSans-Regular">

              RealtyBase © 2025
              <span className="d-block">All Rights Reserved.</span>

            </p>
          </div>

          <div className="col-lg-3 col-md-6 mt-3 mt-lg-0">
            <h6 className="font-face-PlusJakartaSans-Regular">Company</h6>
            <div className="mt-3">
              {pagesData?.map((x, index) => {
                return (
                  <div
                    onClick={() => {
                      navigateToPage(x.linkTo);
                    }}
                    key={index}
                    className="d-flex align-items-start cursor-pointer  font-face-PlusJakartaSans-Regular"
                  // style={{ fontWeight: "600" }}
                  >
                    <h5 className="py-1">{x.title}</h5>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mt-3 mt-lg-0">
            <h6 className="font-face-PlusJakartaSans-Regular py-2">Legal</h6>
            <div className="mt-md-3">
              {legalData?.map((x, index) => {
                return (
                  <div
                    onClick={() => navigateToPage(x.linkTo)}
                    key={index}
                    className="d-flex align-items-start cursor-pointer  font-face-PlusJakartaSans-Regular"
                  // style={{ fontWeight: "600" }}
                  >
                    <h5 className="py-1">{x.title}</h5>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-lg-2 col-md-6 mt-3 mt-lg-0 ">
            <div className="d-flex flex-row flex-md-column  gap-2">
              <div>
                {" "}
                <a
                  href="https://apps.apple.com/us/app/realtybase/id1581598890"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Appstorelogo} />
                </a>
              </div>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.laytra.realestate&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Appstorelogo1} alt="Download from Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
